import { NavLink, Link } from 'react-router-dom';
import React, { useState } from 'react';

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [treatmentsDropdownOpen, setTreatmentsDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const linkBase = 'px-3 py-2 text-smX font-semibold transition';
  const activeBase = 'text-white';
  const inactiveBase = 'text-white/80 hover:text-white';

  const treatments = [
    { name: 'Fertility Enhancing Laparoscopic & Hysteroscopic Surgery', path: '/treatments/fertility-enhancing-surgery' },
    { name: 'Laparoscopic Hysterectomy', path: '/treatments/laparoscopic-hysterectomy' },
    { name: 'Laparoscopic Myomectomy', path: '/treatments/laparoscopic-myomectomy' },
    { name: 'High Risk Pregnancy Care', path: '/treatments/high-risk-pregnancy' },
    { name: 'Infertility Evaluation', path: '/treatments/infertility-evaluation' },
    { name: 'Intrauterine Insemination (IUI)', path: '/treatments/intrauterine-insemination' },
    { name: 'In Vitro Fertilization (IVF) & ICSI', path: '/treatments/ivf-icsi' },
    { name: 'Male Infertility : Surgical Sperm Retrieval : TESA, PESA, MICRO TESE', path: '/treatments/male-infertility' },
  ];

  return (
    <nav className="relative">
      {/* Burger button for mobile */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="md:hidden p-2 text-white"
        aria-label="Toggle menu"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      {/* Desktop menu */}
      <ul className="hidden md:flex flex-wrap items-center gap-4 text-white">
        <li>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              `${linkBase} ${isActive ? activeBase : inactiveBase}`
            }
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/about"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? activeBase : inactiveBase}`
            }
          >
            About
          </NavLink>
        </li>
        <li className="relative group">
          <button
            className={`${linkBase} ${inactiveBase} flex items-center gap-1`}
            onMouseEnter={() => setTreatmentsDropdownOpen(true)}
            onMouseLeave={() => setTreatmentsDropdownOpen(false)}
          >
            Treatments
            {/* <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg> */}
          </button>
          {/* Desktop Dropdown */}
          <ul
            className={`absolute left-0 mt-0 bg-neutral shadow-lg rounded-md overflow-hidden min-w-max z-50 transition-opacity duration-200 ${
              treatmentsDropdownOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
            }`}
            onMouseEnter={() => setTreatmentsDropdownOpen(true)}
            onMouseLeave={() => setTreatmentsDropdownOpen(false)}
          >
            {treatments.map((treatment, index) => (
              <li key={index}>
                <NavLink
                  to={treatment.path}
                  className={({ isActive }) =>
                    `block px-4 py-3 text-sm whitespace-nowrap transition ${
                      isActive ? 'bg-brand text-white' : 'text-white/80 hover:bg-brand/80 hover:text-white'
                    }`
                  }
                  onClick={() => setTreatmentsDropdownOpen(false)}
                >
                  {treatment.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </li>
        {/* <li>
          <NavLink
            to="/gallery"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? activeBase : inactiveBase}`
            }
          >
            Gallery
          </NavLink>
        </li> */}
        {/* <li>
          <NavLink
            to="/blog"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? activeBase : inactiveBase}`
            }
          >
            Blog
          </NavLink>
        </li> */}
        {/* <li>
          <NavLink
            to="/contact"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? activeBase : inactiveBase}`
            }
          >
            Contact
          </NavLink>
        </li> */}
        <li>
          <NavLink
            to="https://herhealth.co.in/"
            className={({ isActive }) =>
              `${linkBase} ${isActive ? inactiveBase : inactiveBase}`
            }
            target="_blank"
          >
            Her Health
          </NavLink>
        </li>
      </ul>

      {/* Mobile menu overlay */}
      <div className={`fixed inset-0 z-50 bg-neutral md:hidden ${isOpen ? 'block' : 'hidden'}`}>
        <div className={`w-64 bg-neutral h-full p-[50px] transform transition-transform duration-300 ease-in-out w-full ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <button
            onClick={() => setIsOpen(false)}
            className="mb-4 text-white text-4xl absolute right-[50px]"
            aria-label="Close menu"
          >
            ×
          </button>
          <div className='flex justify-center mb-10'>
            <Link to="/" onClick={() => setIsOpen(false)}>
              <img src="/Dr_Priya_Bhave_Logo.png" alt="Dr. Priya Bhave Chittawar Logo" className="h-24" />
            </Link>
          </div>
          <ul className="flex flex-col gap-12 text-white text-center">
            <li>
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `${linkBase} text-4xl ${isActive ? activeBase : inactiveBase}`
                }
                onClick={() => setIsOpen(false)}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  `${linkBase} text-4xl ${isActive ? activeBase : inactiveBase}`
                }
                onClick={() => setIsOpen(false)}
              >
                About
              </NavLink>
            </li>
            <li>
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className={`${linkBase} text-4xl ${inactiveBase} w-full`}
              >
                Treatments
              </button>
              {mobileMenuOpen && (
                <ul className="mt-4 flex flex-col gap-3 text-lg pl-4 border-l-2 border-brand">
                  {treatments.map((treatment, index) => (
                    <li key={index}>
                      <NavLink
                        to={treatment.path}
                        className={({ isActive }) =>
                          `block ${isActive ? activeBase : inactiveBase}`
                        }
                        onClick={() => {
                          setIsOpen(false);
                          setMobileMenuOpen(false);
                        }}
                      >
                        {treatment.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            {/* <li>
              <NavLink
                to="/gallery"
                className={({ isActive }) =>
                  `${linkBase} text-4xl ${isActive ? activeBase : inactiveBase}`
                }
                onClick={() => setIsOpen(false)}
              >
                Gallery
              </NavLink>
            </li> */}
            {/* <li>
              <NavLink
                to="/blog"
                className={({ isActive }) =>
                  `${linkBase} text-4xl ${isActive ? activeBase : inactiveBase}`
                }
                onClick={() => setIsOpen(false)}
              >
                Blog
              </NavLink>
            </li> */}
            {/* <li>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  `${linkBase} text-4xl ${isActive ? activeBase : inactiveBase}`
                }
                onClick={() => setIsOpen(false)}
              >
                Contact
              </NavLink>
            </li> */}
            <li>
              <NavLink
                to="https://herhealth.co.in/"
                className={({ isActive }) =>
                  `${linkBase} text-4xl ${isActive ? inactiveBase : inactiveBase}`
                }
                onClick={() => setIsOpen(false)}
                target="_blank"
              >
                Her Health
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
